

import { HttpServices } from '../../Helper';
import { config } from '../../config';

export const GetParkingDistributionScoresAPI = async () => {

    const result = await HttpServices.get(
        `${config.server_address}/CrmDfm/PropertyRating/GetAllPropertyRatingParkingDistributionScores`)
        .then((data) => data)
        .catch((error) => error.response);
    return result;
  };

  
  export const UpdateParkDistributionScoresAPI = async (body) => {
    const result = await HttpServices.post(
        `${config.server_address}/CrmDfm/PropertyRating/UpdatePropertyRatingParkDistributionScores`, body
    )
        .then((data) => data)
        .catch((error) => error.response.data);
    return result;
};
